import dayjs from 'dayjs';

// 按租户记录本机浏览器当天的提醒，与登录账号无关，登出时保留。
const reminderDates = new Map();
const storagePrefix = 'tenantRenewalReminder:';

/** 获取到期前 30 天内的续费提示；缺少有效订阅信息或已过期时不提示。 */
export function getRenewalReminder(subscription) {
  if (!subscription || !subscription.expirationTime ||
      typeof subscription.day !== 'number' || !Number.isFinite(subscription.day) ||
      subscription.day < 0 || subscription.day > 30) {
    return '';
  }
  const expiration = dayjs(subscription.expirationTime);
  if (!expiration.isValid()) {
    return '';
  }
  return `您的租户订阅将于 ${expiration.format('YYYY-MM-DD')} 到期，剩余 ${subscription.day} 天。请及时联系管理员续费，以免影响正常使用。`;
}

/** 显示前立即占用当日提醒，避免重新登录或切换账号重复弹出。 */
export function claimRenewalReminder(tenantId, now = dayjs()) {
  const key = `${storagePrefix}${tenantId}`;
  const today = now.format('YYYY-MM-DD');
  if (reminderDates.get(key) === today) {
    return false;
  }
  try {
    if (localStorage.getItem(key) === today) {
      return false;
    }
    localStorage.setItem(key, today);
  } catch (error) {
    // 浏览器禁用存储时仍允许登录，当前页面内继续去重。
    console.warn('无法保存租户续费提醒日期', error);
  }
  reminderDates.set(key, today);
  return true;
}
